import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import ScrollFx from './ScrollFx';
import useReveal from '../hooks/useReveal';

export default function Layout() {
  useReveal();
  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden">
      <ScrollFx />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}